import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { eventsQueryKeys } from 'features/events';
import { CraeteTitleCmsrDTO, NotificationApiService } from 'features/notification/api/notification-api.service';
import { queryClient } from 'providers';



const { createNotificationList } = NotificationApiService();

export const useCreateList = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: CraeteTitleCmsrDTO) => {
            return createNotificationList(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: (data:any) => {
                const { ResponseMessage } = data;
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                if(data.ResponseStatus==0){
                    message.error(ResponseMessage)
                }else{
                    message.success(ResponseMessage);
                }
            },
        },
    );
};
